import { autobind } from 'core-decorators';
import PropTypes from 'prop-types';
import { Component } from 'react';
import Message from '/@/components/message';
import { _ } from '/@/locale';
import { formatDate } from '/@/utils';
@autobind
export default class ProductRow extends Component {
    static propTypes = {
        name: PropTypes.string,
        renderName: PropTypes.bool,
        phenology: PropTypes.arrayOf(PropTypes.string).isRequired,
        gdus: PropTypes.arrayOf(PropTypes.number),
        styles: PropTypes.object.isRequired,
    };

    static defaultProps = {
        gdus: [],
    };

    renderDate(date) {
        if (!date) return null;

        const formattedDate = formatDate(new Date(date), { format: 'short' });
        // Split by space to separate day and month, and remove trailing period if present
        const [day, month] = formattedDate.replace(/\.$/, '').split(' ');
        return (
            <div className={this.props.styles.date}>
                {day}
                <br />
                {month}
            </div>
        );
    }

    renderGDU(gdu) {
        if (!gdu) return null;

        return <div className={this.props.styles.gdu}>{gdu} GDU</div>;
    }

    render() {
        const { styles } = this.props;

        return (
            <div className={styles.productRow}>
                {this.props.renderName && <div className={styles.productName}>{this.props.name}</div>}
                {this.props.phenology ? (
                    <div className={styles.stages}>
                        <div className={styles.stage1}>
                            {this.renderDate(this.props.phenology[0])}
                            {this.renderGDU(this.props.gdus[0])}
                        </div>
                        <div className={styles.stage2}>
                            {this.renderDate(this.props.phenology[1])}
                            {this.renderGDU(this.props.gdus[1])}
                        </div>
                        <div className={styles.stage3}>
                            {this.renderDate(this.props.phenology[2])}
                            {this.renderGDU(this.props.gdus[2])}
                        </div>
                        <div className={styles.stage4}>{this.renderDate(this.props.phenology[3])}</div>
                    </div>
                ) : (
                    <Message type='warning' appearance='fill' showIcon>
                        {_('No contamos con información sobre la fenología del producto seleccionado.')}
                    </Message>
                )}
            </div>
        );
    }
}
